
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"hideColumn":"Spalte ausblenden","hideHierarchy":"Hierarchie ausblenden","row":"Zeile","sortingDirection":"Sortierrichtung"},"en":{"hideColumn":"Hide column","hideHierarchy":"Hide hierarchy","row":"Row","sortingDirection":"Sorting direction"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();